var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"adminCatalog"},[_c('h1',[_vm._v("Каталог сайтов")]),_c('vs-button',{staticClass:"adminCatalog__create",attrs:{"to":"/admin/create"}},[_c('i',{staticClass:"bx bx-plus"}),_vm._v(" Добавить сайт ")]),_c('AdminCatalog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }